import { ChainId } from '@pancakeswap/sdk'
import { CHAIN_ID } from './chains'
import { chainTokens } from './tokens'
import { FarmChainConfig, FarmConfig } from './types'


export const farmsInChains: FarmChainConfig = {
  [ChainId.FANTOM_TESTNET] : [
  /*  {
    pid: 0,
    lpSymbol: 'LUM',
    lpAddresses: {
      3: '0xF8c024a08EB3fc8Db555C50e445fcd0B1ee813C6',
      537: '0xa3416DA9709BF169c3f4eaCB367d5A17676637f2',
      4002: '0x364207aEFA09d33b5aFaA2C07D691af03c58D70C', // reward token itself
    },
    token: chainTokens.lum, // serializedTokens.lum,
    quoteToken: chainTokens.smr,
    fee : 0.0,

  }, */
   {
    pid: 1,
    lpSymbol: 'LUM-SMR LP',
    lpAddresses: {
      4002: '0x9CCb19F3a3B5e5AcFa0ECa5DaC47892055D9Fb52',
    },
    token: chainTokens.lum,
    quoteToken: chainTokens.smr,
    fee: 0.0,
    route0: [chainTokens.smr,chainTokens.lum],
    route1: [chainTokens.lum,chainTokens.smr]


  },
  {
    pid: 2,
    lpSymbol: 'BTC-SMR LP',
    lpAddresses: {
      4002: '0x04e70E68Ada9edD051A9336cbE208892D25c953F',
    },
    token: chainTokens.btc,
    quoteToken: chainTokens.smr,
    fee: 1.0,
    route0: [chainTokens.btc,chainTokens.smr],
    route1: [chainTokens.smr,chainTokens.btc],

  },
  {
    pid: 3,
    lpSymbol: 'USDC-SMR LP',
    lpAddresses: {
      4002: '0xfF3D28c604C04342D16c12d7531202A509B2687c',
    },
    token: chainTokens.usdc,
    quoteToken: chainTokens.smr,
    fee: 1.0,
    route0: [chainTokens.usdc,chainTokens.smr],
    route1: [chainTokens.smr,chainTokens.usdc]


  },
  {
    pid: 4,
    lpSymbol: 'ETH-SMR LP',
    lpAddresses: {
      4002: '0x9756cD3e9F35e4a02A7E8206D6F188873a3B0443'
    },
    token: chainTokens.seth,
    quoteToken: chainTokens.smr,
  /*  dualToken: chainTokens.bolt,
    rewarder: {
      4002: "0xA431209172A1bf97f38d7600d384cC110261ab74"
    }, */
    fee: 1.0,
    route0: [chainTokens.seth,chainTokens.smr],
    route1: [chainTokens.smr,chainTokens.seth]

  },
  {
    pid: 5,
    lpSymbol: 'BNB-SMR LP',
    lpAddresses: {
      4002: '0x2b21053554d04936cEf5b235CAcc23E380C77741'
    },
    token: chainTokens.sbnb,
    quoteToken: chainTokens.smr,
    fee: 1.0,
    route0: [chainTokens.sbnb,chainTokens.smr],
    route1: [chainTokens.smr,chainTokens.sbnb]

  },
  {
    pid: 6,
    lpSymbol: 'BTC-ETH LP',
    lpAddresses: {
      4002: '0xe7592F162014cd6cE12f6a6e23f2b6277bEbcfdd'
    },
    token: chainTokens.btc,
    quoteToken: chainTokens.seth,
    fee: 1.0,
    route0: [chainTokens.btc,chainTokens.smr,chainTokens.seth],
    route1: [chainTokens.seth,chainTokens.btc]

  },
  {
    pid: 7,
    lpSymbol: 'USDT-USDC LP',
    lpAddresses: { 4002: '0xac17fE2EF318b1EB1F326cc16cD1cc162e24c5a9' },
    token: chainTokens.usdt,
    quoteToken: chainTokens.usdc,
    fee: 1.0,
    route0: [chainTokens.usdt,chainTokens.usdc],
    route1: [chainTokens.usdc,chainTokens.usdt]


  },
  {
    pid: 8,
    lpSymbol: 'BUSD-USDC LP',
    lpAddresses: { 4002: '0xF1B1C4bf6F01d815687126a1edFe3BDFA5E30DA9' },
    token: chainTokens.busd,
    quoteToken: chainTokens.usdc,
    fee: 1.0,
    route0: [chainTokens.busd,chainTokens.usdc],
    route1: [chainTokens.usdc,chainTokens.busd]


  },
  /*
  {
    pid: 11,
    lpSymbol: 'MLUM-SMR LP',
    lpAddresses: { 4002: '0xa091589b2afDCfB2784C37423cF0EB86aB5cf0Fd' },
    token: chainTokens.magicLum,
    quoteToken: chainTokens.smr,
    fee: 0
  } */
  ],
// shimmer_evm / training dex
[CHAIN_ID.SHIMMER] : [
  {
    pid: 1,
    lpSymbol: 'LUM-SMR LP',
    lpAddresses: {
      1073: '0x78d71a8C246c1181e5A34445aca332d0d7720862'
    },
    token: chainTokens.lum,
    quoteToken: chainTokens.smr,
    fee: 0.0,

  },
  {
    pid: 2,
    lpSymbol: 'BOLT-SMR LP',
    lpAddresses: {
      1073: '0x62Bf5b84e1939C991C9B90409039Cf31d11e67C9'
    },
    token: chainTokens.bolt,
    quoteToken: chainTokens.smr,
    fee: 0.0,

  },
  {
    pid: 3,
    lpSymbol: 'USDT-SMR LP',
    lpAddresses: {
      1073: '0x3e7e867bAacb015f4190cdB8e12CBA528b4C264b'
    },
    token: chainTokens.usdt,
    quoteToken: chainTokens.smr,
    fee: 0.0,
  },
],
}


const farms: FarmConfig[] = [
  /**
   * These 3 farms (PID 0, 251, 252) should always be at the top of the file.
   */
   {
    pid: 0,
    lpSymbol: 'LUM',
    lpAddresses: {
      3: '0xF8c024a08EB3fc8Db555C50e445fcd0B1ee813C6',
      537: '0xa3416DA9709BF169c3f4eaCB367d5A17676637f2',
      4002: '0x364207aEFA09d33b5aFaA2C07D691af03c58D70C', // reward token itself
      1115: '0x4fb5D3A06f5dE2E88Ce490E2E11D22B840D5ac47'
    },
    token: chainTokens.lum, // serializedTokens.lum,
    quoteToken: chainTokens.smr,
    fee : 0.0,

  },
   {
    pid: 1,
    lpSymbol: 'LUM-SMR LP',
    lpAddresses: {
      3: '0xb0e190c0a6A001D7F5a7BdeD69662e2c3D9616C8',
      537: '0xa3416DA9709BF169c3f4eaCB367d5A17676637f2',
      4002: '0xECaDDe8a10e9ac5598F36B105da90fbE9fF36c10',
      1115: '0xCaCb9D123521beE0F85691bad58A0542bea008f8'
    },
    token: chainTokens.lum,
    quoteToken: chainTokens.smr,
    fee: 0.0,

  },
  {
    pid: 2,
    lpSymbol: 'DAI-SMR LP',
    lpAddresses: {
      3: '0x94A522609CB5Af31D9FAF9353FA67F5C7ad12870',
      537: '0x0AFD6c082aa17EcFc28b7eF0C3FfAAC5c8f37e61',
      4002: '0xd2776FA55D49a251FAb52Cb3B408D5d22B609650',
      1115: '0x72e2b88DCD5C40d5745d56106E72a436f29Deafa'
    },
    token: chainTokens.dai,
    quoteToken: chainTokens.smr,
    fee: 1.0,

  },
  {
    pid: 3,
    lpSymbol: 'USDC-SMR LP',
    lpAddresses: {
      3: '0x0F17dEebA21e68445a327e5C673404fFe896B431',
      537: '0x6fADb4bA596a2ec1c5a42E93Be1Fa39E6dfa3414',
      4002: '0x851dB0b27D4e9AfF22af6f6E7928ae4FA96d5259',
      1115: '0xA58bCff165a885C5E8417e071D8cC4Ee754886c5'
    },
    token: chainTokens.usdc,
    quoteToken: chainTokens.smr,
    fee: 0.0,
  },
  {
    pid: 4,
    lpSymbol: 'USDT-SMR LP',
    lpAddresses: {
      3: '0x3E72e076834c7D30555A6042212b87C993FF66D9',
      537: '0x041645d47B1968c4f1B8cC691b669096dae1A9c2',
      4002: '0x1823c8eDEa9BfD10c5Af82A593C1e57D01B58362',
      1115: '0x7DB9aDBDA02afd4D6A07186Fba262a3428Ec2631'
    },
    token: chainTokens.usdt,
    quoteToken: chainTokens.smr,
    fee: 1.0,
    rewarder: {
      4002: '0xf27483FeBd8F115E8C54dA20cBC84c073412dE2D'
    },
    dualToken: chainTokens.bolt
  },
  {
    pid: 5,
    lpSymbol: 'AVAX-SMR LP',
    lpAddresses: {
      4002: '0xF4fBd6b0A2d575554F50005B9b393bfbbbE059f0'
    },
    token: chainTokens.avax,
    quoteToken: chainTokens.smr,
    fee: 1.0
  },
  {
    pid: 6,
    lpSymbol: 'ETH-SMR LP',
    lpAddresses: {
      4002: '0xa339076bBC9924a20682c6fbec89a195826b46f8'
    },
    token: chainTokens.seth,
    quoteToken: chainTokens.smr,
    fee: 0
  },
  {
    pid: 7,
    lpSymbol: 'BNB-SMR LP',
    lpAddresses: {
      4002: '0x90eF631175B20Ca48a24b79a9cc2a3f8e6E59a35'
    },
    token: chainTokens.sbnb,
    quoteToken: chainTokens.smr,
    fee: 0
  },
  {
    pid: 8,
    lpSymbol: 'BTC-SMR LP',
    lpAddresses: { 4002: '0x44750A73B98309D7E0693e407178D9a92019F2Df' },
    token: chainTokens.btc,
    quoteToken: chainTokens.smr,
    fee: 0
  },
  {
    pid: 9,
    lpSymbol: 'BTC-ETH LP',
    lpAddresses: { 4002: '0x75930ad73f5BFDb52d845fa35c15B756209F656f' },
    token: chainTokens.btc,
    quoteToken: chainTokens.seth,
    fee: 0
  },
  {
    pid: 10,
    lpSymbol: 'BUSD-USDC LP',
    lpAddresses: { 4002: '0xc1F7B1dB9f6494FAc36F72D078827B93b1794166' },
    token: chainTokens.busd,
    quoteToken: chainTokens.usdc,
    fee: 0
  },
 /* {
    pid: 11,
    lpSymbol: 'USDT-USDC LP',
    lpAddresses: { 4002: '0xf99E594872c03D44DE5b39900F7e72A92801f36D' },
    token: serializedTokens.usdt,
    quoteToken: serializedTokens.usdc,
    fee: 0
  }, */
  {
    pid: 11,
    lpSymbol: 'MLUM-SMR LP',
    lpAddresses: { 4002: '0xa091589b2afDCfB2784C37423cF0EB86aB5cf0Fd' },
    token: chainTokens.magicLum,
    quoteToken: chainTokens.smr,
    fee: 0
  }

  /*
  {
    pid: 5,
    lpSymbol: 'HERO-ETH LP',
    lpAddresses: {
      1074: '0xA586F269F8926Ab6AcC29f0a9D0de7E6b0199E4f',
    },
    token: serializedTokens.hero,
    quoteToken: serializedTokens.weth,
  },
  {
    pid: 6,
    lpSymbol: 'FUN-ETH LP',
    lpAddresses: {
      1074: '0xD229C0C84092a3fd9c0ACCf7c67BbdBcE0D948aa',
    },
    token: serializedTokens.fun,
    quoteToken: serializedTokens.weth,
  },
  {
    pid: 7,
    lpSymbol: 'PEARL-IOTA LP',
    lpAddresses: {
      1074: '0xd7F81b8695A55cf2eA00B58d81BC61AbcC570773',
    },
    token: serializedTokens.pearl,
    quoteToken: serializedTokens.iota
  },
  {
    pid: 8,
    lpSymbol: 'IOTA-USDC LP',
    lpAddresses: {
      1074: '0x88423CcE227b14b835BfbD1Fbba6f0d32d9414F8',
    },
    token: serializedTokens.iota,
    quoteToken: serializedTokens.usdc
  }
  */
]

// export default farms

export default farmsInChains
